export class admCatDocumentDetails {
}